<template>
  <ValidationObserver
    ref="saveTuitionCardTemplateModal"
  >
    <b-modal
      id="save-tuition-card-template-modal"
      ref="save-tuition-card-template-modal"
      :title="title"
      centered
      no-close-on-backdrop
      :ok-title="title"
      cancel-variant="outline-secondary"
      size="sm"
      class="p-0"
      @ok.prevent="save"
      @show="setData"
    >
      <b-form-group
        label="Tuition Card Template Title"
      >
        <ValidationProvider
          #default="{ errors }"
          name="Tuition Card Template Title"
          rules="required"
        >
          <b-form-input
            v-model="name"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </b-form-group>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { BModal, BFormGroup, BFormInput } from 'bootstrap-vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { appTuitionCardTemplate } from '@/store/modules/app-tuition-card-templates/app-tuition-card-template-item'

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,

    ValidationProvider,
    ValidationObserver,
  },
  props: {
    tuitionCardTemplateName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      name: '',
      required,
    }
  },
  computed: {
    title() {
      return 'Save As'
    },
  },
  watch: {
    tuitionCardTemplateName(val) {
      this.name = val
    },
  },
  methods: {
    setData() {
      this.name = this.tuitionCardTemplateName
    },
    save() {
      return new Promise((resolve, reject) => {
        this.$refs.saveTuitionCardTemplateModal.validate().then(success => {
          if (success) {
            resolve(true)
            appTuitionCardTemplate.mutations.SET_NEW_NAME(this.name)
            appTuitionCardTemplate.actions.saveAsTuitionCardTemplate()
            this.$refs['save-tuition-card-template-modal'].toggle('#toggle-btn')
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style>

</style>
